import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export { useNotification } from './useNotification';
export { useStyle } from './useStyle';
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = useDispatch<AppDispatch>;
